import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { ImageUrl } from '../../../../../Helpers/request';
import { LazyLoadImage } from "react-lazy-load-image-component";
const DiscoverSection2 = () => {
  return (
    <section className="discover_all2">
        <Container>
            <div className="discover_box2">
                <Row>
                    <Col md={6} className='p-0'>
                        <div className="discover_boximg21 aos-init aos-animate" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
                            <LazyLoadImage src={`${ImageUrl}theme/tokyo/nackles_image.jpg`} className="img-responsive w-100" alt="img" />
                        </div>
                    </Col>
                    
                    <Col md={6} className='p-0 pl-md-3 pl-0'>
                        <div className="discover_boxcontent2 aos-init aos-animate" data-aos="fade-down" data-aos-easing="linear" data-aos-duration="1500">
                            <div className="discover_boxcontentin2">
                                <div className="beauty_content">
                                    <h2>Necklaces</h2>
                                    <p>Find the perfect length for every occasion with classic pearl strands, diamond elegance, colorful gemstones and more!</p>
                                    <div className="discover_btn">
                                        <Link className="main_button" to="/jewelry/necklace">Explore the Collection</Link>
                                    </div>
                                </div>		
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </Container>
    </section>
  )
}

export default DiscoverSection2